import { useEffect } from "react"
import { useSearchParams, useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetStoreManagerStoreTicketRecord = () => {
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/admin/store/manager/${idx}/ticket/record?page=${page}`)
    }, [page])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "account_idx") setAlert("매니저 idx를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "page") setAlert("페이지 번호를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("매니저 데이터가 존재하지 않습니다.")
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetStoreManagerStoreTicketRecord